import engineUserAgent from './engine-user-agent.js';

var userAgent = engineUserAgent;
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);

export { engineIsIos as default };
